import axios from "axios";
import { myApi } from "../../../constants/consts";

const api = axios.create({ baseURL: myApi, timeout: 10000 });

// Kullanıcı bilgisi önbelleği: aynı kullanıcı için tekrarlayan istekleri engeller.
// TTL kısa tutuldu (profil değişiklikleri kısa sürede yansır); başarısız istekler önbelleğe alınmaz.
const USER_CACHE_TTL_MS = 5 * 60 * 1000;
const userCache = new Map(); // key -> { ts, promise }

// user_id: sayı veya "all" olabilir — güvenli dönüşüm
const toUserId = (v) => (v === "all" ? "all" : Number(v));

export const supporterService = {
  /* ─────────── Destek listesi ─────────── */
  async getSupportsBySupporter({ supporter }) {
    const { data } = await api.get("/get_supports_by_supporter_optimized", {
      params: { supporter },
    });
    return Array.isArray(data) ? data : [];
  },

  async getSupportsFilter({ personel, durum }) {
    const { data } = await api.get("/get_supports_filter", {
      params: { personel, durum },
    });
    return Array.isArray(data) ? data : [];
  },

  /* ─────────── Polling ─────────── */
  // async checkDataIsUpdated({ userId }) {
  //   const { data } = await api.post("/check_data_is_updated", {
  //     target: "nortek", // destekçiye müşteri tarafından yazılan flag
  //     user_id: toUserId(userId),
  //     root: "support",
  //   });
  //       console.log("Support data is updated:", data.data);
  //   return data?.data === true; // messagesService ile aynı davranış
  // },
  async checkDataIsUpdated({ userId, root = "support" }) {
    const { data } = await api.post("/check_data_is_updated", {
      target: "nortek",
      user_id: toUserId(userId),
      root,
    });
    return data?.data === true;
  },
  async changeUpdateValue({ target, newValue, userId, root }) {
    const { data } = await api.post("/change_status_update_value", {
      target,
      new_value: newValue,
      user_id: toUserId(userId),
      root,
    });
    return data;
  },

  /* ─────────── Status / iptal ─────────── */
  async updateSupportStatus({
    supportId,
    status,
    supporter,
    note,
    statusFrom,
  }) {
    const { data } = await api.post("/update_support", {
      supportId,
      status,
      supporter,
      note,
      status_From: statusFrom,
    });
    return data;
  },

  async cancelSupport({ supportId, note }) {
    const { data } = await api.post("/cancel_support", { supportId, note });
    return data;
  },

  /* ─────────── Kullanıcı / şirket ─────────── */
  async getUserById(userId) {
    const key = String(userId);
    const hit = userCache.get(key);
    if (hit && Date.now() - hit.ts < USER_CACHE_TTL_MS) return hit.promise;

    const promise = (async () => {
      const { data } = await api.get("/get_user_by_id", {
        params: { user_id: userId },
      });
      const user = Array.isArray(data) ? data[0] : data;
      if (!user) return {};
      return {
        username: user.username ?? "",
        email: user.email ?? "",
        phone: user.phone ?? "",
        sunucu_kodu: user.sunucu_kodu ?? "",
      };
    })();

    userCache.set(key, { ts: Date.now(), promise });
    // Hata durumunda önbelleği temizle ki sonraki çağrı tekrar denesin
    promise.catch(() => {
      if (userCache.get(key)?.promise === promise) userCache.delete(key);
    });
    return promise;
  },

  async getCompanyBySunucu(sunucuKodu) {
    const { data } = await api.post("/get_all_company_by_sunucu", {
      sunucu_kodu: sunucuKodu,
    });
    return Array.isArray(data) ? data : [];
  },
};
